import request from "@/utils/request";

// 登录
export function login(data) {
  return request({
    url: "/adminApi/admin/login/adminLogin",
    method: "post",
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
  })
}

// 获取用户信息
export function getInfo() {
  return request({
    url: '/adminApi/admin/login/getAdminInfo',
    method: "post"
  })
}

// 退出登录
export function logout() {
  return request({
    url: "/adminApi/admin/login/outLogin",
    method: "post"
  })
}
export function changeCo(data) {
  return request({
    url: '/adminApi/admin/login/changeEnterprise',
    method: "post",
    data
  })
}

